import { authHeader } from '@/_helpers';
export const targetsService = {
    verificateTarget,
    getAll,
    getApollo,
    addTarget,
    updatedOrderClosed,
    getTarget,
    getTargetListByClient,
    getTargetListByClientAndStatus,
    updateTarget,
    getContactUsed,
    getContactedOrder,
    getCampaignForOrder,
    getApiKeys,
    getTotalTargetActive,
    addCampaignStep,
    loadCampaingStepTarget,
    getTargetMissingData

};

const apiUrl = process.env.VUE_APP_ROOT_API;
var lastquery = new Array();
function getAll(client_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id })
    };
    return fetch(`${apiUrl}/targets/get`, requestOptions).then(handleResponse);
}

function updatedOrderClosed(data){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data : {closed: data.closed} })
};
return fetch(`${apiUrl}/targets/update-closed/${data.target_id}`, requestOptions)
    .then(handleResponse);
}

function addTarget(data){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ data })
    };
    return fetch(`${apiUrl}/targets/add-target`, requestOptions)
        .then(handleResponse);
}

function getContactUsed(id){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ id })
    };
    return fetch(`${apiUrl}/targets/get-target-contact-used`, requestOptions)
        .then(handleResponse);
}

function verificateTarget(data){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ data })
    };
    return fetch(`${apiUrl}/targets/addVerification`, requestOptions)
        .then(handleResponse);
}

function getTarget(target_id){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ target_id })
    };
    return fetch(`${apiUrl}/targets/get-target`, requestOptions)
        .then(handleResponse);
}

function updateTarget(data){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify( data )
    };
    return fetch(`${apiUrl}/targets/update-target`, requestOptions)
        .then(handleResponse);
}

function getContactedOrder(target_id){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ target_id })
    };
    return fetch(`${apiUrl}/targets/get-contacted-order`, requestOptions)
        .then(handleResponse);
}

function getCampaignForOrder(target_id){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ target_id })
    };
    return fetch(`${apiUrl}/targets/get-campaign-order`, requestOptions)
        .then(handleResponse);
}



function addCampaignStep(data){

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ data })
    };
    return fetch(`${apiUrl}/targets/add-target-campaign-step`, requestOptions)
        .then(handleResponse);
}


function getTargetListByClient(client_id) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id })
    };
    return fetch(`${apiUrl}/targets/get-target-list-by-client`, requestOptions)
           .then(handleResponse);
}

function getTargetListByClientAndStatus(data) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify( data )
    };
    return fetch(`${apiUrl}/targets/get-target-list-by-client`, requestOptions)
           .then(handleResponse);
}


function getApollo(data) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ data })
    };
    return fetch(`${apiUrl}/targets/get-apollo`, requestOptions)
        .then(handleResponse);
}

function getApiKeys() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/targets/apollo-apis`, requestOptions).then(handleResponse);
}

function getTotalTargetActive() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/targets/total-active`, requestOptions).then(handleResponse);
}

function loadCampaingStepTarget (data){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify( data )
    };
    return fetch(`${apiUrl}/targets/load-campaing-step-target`, requestOptions).then(handleResponse);
}

function getTargetMissingData(){
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/targets/target-missing-data`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
